import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import action from '../../Redux Store/actions';
import { supabase } from '../../supabaseClient';
//CSS
import cssClasses from './Token.module.css';

//ICONS
import AddIcon from '@mui/icons-material/Add';
import noTokenImg from '../../Assets/Images/Token/Illustrations.svg';
import EditIcon from '@mui/icons-material/Edit';
import dropDownIcon from '../../Assets/Images/Common/dropDownIcon.svg';

//SUBCOMPONENTS
import DropDown from '../../Subcomponents/DropDown';
import SearchBar from '../../Subcomponents/Search';
import Datagrid from '../../Subcomponents/Datagrid';
import ProjectIcon from '../../Assets/Images/Sustenance/ProjectIcon.svg';
import Button from '../../Subcomponents/Button';
import AddTokenModal from '../../Modals/AddToken/AddTokenModal';
import checked from '../../Assets/Images/Common/checked.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { errorTost, offlineToast, successTost } from '../../Services/Toast';
import {
  Box,
  Checkbox,
  ClickAwayListener,
  Divider,
  FormControlLabel,
  FormGroup,
  Slider,
} from '@mui/material';
import DateComponent from '../../Subcomponents/DateComponent';
import { Network } from '@capacitor/network';
import _, { debounce, findIndex, orderBy } from 'lodash';
import PlusIcon from '../Icons/PlusIcon';
import { DataGrid } from '@mui/x-data-grid';
import { dismissLoader, presentLoader } from '../../Services/loader';
import { getAllTokenFromServer } from '../../Services/Tokens';

const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',

  },
  '&.MuiDataGrid-root': {
    height: "84%",

  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },

  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};

function Token() {
  const dispatch = useDispatch();
  const [tokenData, setTokenData] = useState({
    name: '',
    isPreselect: false,
    isPriorityPass: false,
    validity: null,
    inventoryTypeId: null,
    prerequisiteId: null,
    // modeOfPayments: [],
    amount: '',
    isRefundable: 'Yes',
    paymentType:false,
    shortCode: '',
    NoOfBookingAllow:'',
    isLocationEnabled: false,
    locations: [],
    isUnitTypeEnabled: false,
    unitTypes: [],
    allowedLeadTypes: []
  });
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState('Latest First');
  // const rows = [
  //   {
  //     id: 1,
  //     name: "Priority Pass",
  //     isPreselect: true,
  //     prerequisiteId: "GT 2",
  //     inventoryTypeId: "2 BHK",
  //     validity: 45,
  //     amount: "25,000",
  //     modeOfPayments: ["cash", "cheque"],
  //     isRefundable: false,
  //   },
  //   {
  //     id: 2,
  //     name: "Priority Pass 1",
  //     isPreselect: true,
  //     prerequisiteId: "GT 2",
  //     inventoryTypeId: "2 BHK",
  //     validity: 45,
  //     amount: "25,000",
  //     modeOfPayments: ["cheque"],
  //     isRefundable: true,
  //   },
  //   {
  //     id: 3,
  //     name: "Priority Pass 2",
  //     isPreselect: true,
  //     prerequisiteId: "GT 2",
  //     inventoryTypeId: "2 BHK",
  //     validity: 45,
  //     amount: "25,000",
  //     modeOfPayments: ["UPI"],
  //     isRefundable: true,
  //   },
  // ];
  // const handlePaymentSelection = (e) => {
  //   console.log(e.target.checked);
  //   if (e.target.checked) {
  //     paymentArr.push(e.target.value);
  //   } else {
  //     // debugger;
  //     setPaymentArr(paymentArr.filter((f) => f !== e.target.value));
  //     console.log(paymentArr);
  //   }
  //   if (paymentArr.length === 0) {
  //     setHelperText({
  //       ...helperText,
  //       isModeOfPaymentSelected: "Please Select Mode Of Payment",
  //     });
  //   } else {
  //     setHelperText({
  //       ...helperText,
  //       isModeOfPaymentSelected: "",
  //     });
  //   }
  //   setTokenData({
  //     ...tokenData,
  //     modeOfPayments: paymentArr,
  //   });
  // };
  const TokenGridColumns = [
    {
      field: 'Action',
      width: 80,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              gap: '1rem',
            }}
          >
            <EditIcon
              sx={{ fontSize: '2rem', cursor: 'pointer' }}
              onClick={() => {
                const selectedRow = TokenArray.filter(
                  (row) => row.id === params.row.id
                );
                console.log('selectedRow', selectedRow)
                setCustomerRefund(selectedRow[0]?.canCustomerRefund)
                setTokenData(...selectedRow);
                // setPaymentArr(selectedRow[0].modeOfPayments);
                setUpdateData(true);
                setModalType('Edit Token');
                setFilterType('None');
                setShowDates(false);
                setShowPriceRange(false);
                setCheckBoxDropDown([]);
                setSelectedFilter('None');
                // setSortType('latest first');
                document.getElementById(
                  'input-with-icon-textfield Search'
                ).value = '';
                setSearchKey('');
                setOpenAddTokenModal(true);
              }}
            />
          </div>
        );
      },
    },
    { field: 'id', hide: true, sortable: false },
    {
      field: 'name',
      headerName: 'Token Name',
      sortable: false,
      width: 415,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.SubContainer}>
            <img src={ProjectIcon} alt={''} />
            <Box ml={1} mt={1} className={cssClasses.innerTitle}>
              {params.row.name ? params.row.name : ''}
            </Box>
          </Box>
          // <div
          //   style={{
          //     display: 'flex',
          //     alignItems: 'center',
          //     gap: '1rem',
          //   }}
          // >
          //   <div
          //     style={{
          //       background: '#FDB022',
          //       borderRadius: '50%',
          //       textAlign: 'center',
          //     }}
          //   >
          //     <img style={{ margin: '0.8rem 1rem 0.4rem 1rem' }} alt='' />
          //   </div>
          //   <div>
          //     <p>{params.row.name}</p>
          //   </div>
          // </div>
        );
      },
    },
    {
      field: 'tokentype',
      headerName: 'Token Type',
      sortable: false,
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row.isPriorityPass === true
              ? 'Priority Pass'
              : params.row.isPreselect === true
                ? 'Preselect'
                : params.row.isPreselect === false &&
                  params.row.isPriorityPass === false
                  ? 'None'
                  : ''}
          </div>
        );
      },
    },
    {
      field: 'isRefundable',
      headerName: 'Refundable',
      sortable: false,
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row.isRefundable === true ? "Yes" : "No"}
          </div>
        );
      },
    },
    {
      field: 'prerequisiteId',
      headerName: 'Pre requisite',
      sortable: false,
      minWidth: 250,
      renderCell: (params) => {
        return (
          <div style={{ textAlign: 'center' }}>
            {TokenArray.filter(
              (token) => token.tokenId === params.row.prerequisiteId
            )[0]?.name
              ? TokenArray.filter(
                (token) => token.tokenId === params.row.prerequisiteId
              )[0]?.name
              : '-'}
          </div>
        );
      },
    },
    {
      field: 'inventoryTypeId',
      headerName: 'Unit type',
      sortable: false,
      width: 150,
      renderCell: (params) => {
        return (
          <div>
            {
              unitType.filter(
                (unit) => unit.inventoryTypeId === params.row.inventoryTypeId
              )[0]?.type
            }
          </div>
        );
      },
    },
    {
      field: 'amount',
      headerName: 'Token Price',
      sortable: false,
      width: 150,
      renderCell: (params) => {
        return <div>₹ {numberWithCommas(params.row.amount)}</div>;
      },
    },
    {
      field: 'validity',
      headerName: 'Token validity days',
      sortable: false,
      width: 200,
      renderCell: (params) => {
        return <div>{`${params.row.validity} days`}</div>;
      },
    },
  ];
  const [modalType, setModalType] = useState('Add Token');
  const navigate = useNavigate();
  const [openAddTokenModal, setOpenAddTokenModal] = useState(false);
  // const [paymentArr, setPaymentArr] = useState([]);
  const [updateData, setUpdateData] = useState(false);
  const [filterType, setFilterType] = useState('None');
  // const [sortType, setSortType] = useState('latest first');
  const [searchKey, setSearchKey] = useState('');
  const [showDropDown, setShowDropDown] = useState(false);
  const [customerRefund, setCustomerRefund] = useState(false)
  const [selectFilter, setSelectedFilter] = useState('None');
  const [checkBoxDropDown, setCheckBoxDropDown] = useState();
  const [InventoryTypeFilter, setInventoryTypeFilter] = useState([]);
  const [selectDates, setSelectDates] = useState([
    { label: 'StartDate', value: '' },
    { label: 'EndDate', value: '' },
    { label: 'Time', value: '' },
  ]);
  const [showDates, setShowDates] = useState(false);
  const [showPriceRange, setShowPriceRange] = useState(false);
  const [priceRange, setPriceRange] = useState([10000, 100000]);
  const [listOfDropDown, setListOfDropDown] = useState([
    { label: 'None', select: true },
    { label: 'Token Type', select: false },
    { label: 'Refundable', select: false },
    { label: 'Token Validity', select: false },
    // 'None',
    // 'Inventory Type',
    // "Price Range",
    // "Date Range",
  ]);

  const [selectedTokenType, setSelectedTokenType] = useState([]);
  const [selectedRefundable, setSelectedRefundable] = useState([]);
  const [selectedTokenValidity, setSelectedTokenValidity] = useState([]);
  const [TokenCount, setTokenCount] = useState(0);
  const [NoTokensFound, setNoTokensFound] = useState(null);
  const [search, setSearch] = useState("");

  //*Main-DropDown
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);

  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(12);

  //*Token-Type-DropDown
  const [showAllTokenTypeDropDown, setShowAllTokenTypeDropDown] =
    useState(false);
  const [AllTokenTypesDropDown, setAllTokenTypesDropDown] = useState([
    { label: 'None', value: false },
    { label: 'Priority Pass', value: false },
    { label: 'Preselect', value: false },
  ]);

  //*Refundable-DropDown
  const [showAllRefundableDropDown, setShowAllRefundableDropDown] =
    useState(false);
  const [AllRefundableDropDown, setAllRefundableDropDown] = useState([
    { label: 'Yes', value: false },
    { label: 'No', value: false },
  ]);

  //*Token-Validity-Dropdown
  const [showAllTokenValidityDropDown, setShowAllTokenValidityDropDown] =
    useState(false);
  const [AllTokenValidityDropDown, setAllTokenValidityDropDown] = useState([
    { label: '45', value: false },
    { label: '60', value: false },
    { label: '90', value: false },
  ]);

  const [helperText, setHelperText] = useState({
    isNameValid: '',
    isValiditySelected: '',
    isUnitTypeSelected: '',
    isModeOfPaymentSelected: '',
    isAmountValid: '',
    shortCode: '',
    NoOfBookingAllow: '',
  });

  const emptyHelperTextData = () => {
    setHelperText({
      isNameValid: '',
      isValiditySelected: '',
      isUnitTypeSelected: '',
      isModeOfPaymentSelected: '',
      isAmountValid: '',
    });
  };

  const [unitType, setUnitType] = useState([]);
  // const [tokenArr, setTokenArr] = useState([]);
  const [TokenArray, setTokenArray] = useState([]);
  const [filteredTokenArr, setFilteredTokenArr] = useState([]);
  async function getUnitType() {
    // ! loaders & internet connectivity check remaining
    let { data: InventoryType, error } = await supabase
      .from('InventoryType')
      .select('*');
    if (InventoryType) {
      const inventoryTypes = _.uniqBy(InventoryType, 'type');
      setUnitType(inventoryTypes);
      console.log(inventoryTypes);
    } else if (error) {
      console.log(error.message);
    }
    // ! error handling remaining
  }
  // function sortAscName(property) {
  //   var sortOrder = 1;
  //   if (property[0] === '-') {
  //     sortOrder = -1;
  //     property = property.substr(1);
  //   }
  //   return function (a, b) {
  //     var result =
  //       a[property].toLowerCase() < b[property].toLowerCase()
  //         ? -1
  //         : a[property].toLowerCase() > b[property].toLowerCase()
  //         ? 1
  //         : 0;
  //     return result * sortOrder;
  //   };
  // }

  function getAllTokens(
    _pageNumber,
    merge,
    search,
    drpDownSelectedVal,
    selectedTokenType,
    selectedRefundable,
    selectedTokenValidity
  ) {
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getAllTokenFromServer(
          _pageNumber * pageSize,
          _pageNumber * pageSize + pageSize - 1,
          search,
          drpDownSelectedVal,
          selectedTokenType,
          selectedRefundable,
          selectedTokenValidity,
        ).then((resp) => {
          dismissLoader();
          setTokenCount(resp.count);
          if (resp.count > 0) {
            setNoTokensFound(true)
          } else {
            setNoTokensFound(false)
          }
          console.log("current-Data", resp.data)
          const arr = resp.data.map((el, index) => ({
            ...el,
            id: el.tokenId,
            index: index,
          }))
          if (merge) {
            setTokenArray((pre) => [...pre, ...arr])
          } else {
            setTokenArray([...arr])
          }



        }).catch((err) => {
          dismissLoader();
        });
      } else {
        offlineToast();
      }
    });
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  }
  // function sortDscName(property) {
  //   var sortOrder = 1;
  //   if (property[0] === '-') {
  //     sortOrder = -1;
  //     property = property.substr(1);
  //   }
  //   return function (a, b) {
  //     var result =
  //       a[property].toLowerCase() > b[property].toLowerCase()
  //         ? -1
  //         : a[property].toLowerCase() > b[property].toLowerCase()
  //         ? 1
  //         : 0;
  //     return result * sortOrder;
  //   };
  // }

  // function sortAscDate(property) {
  //   var sortOrder = 1;
  //   if (property[0] === '-') {
  //     sortOrder = -1;
  //     property = property.substr(1);
  //   }
  //   return function (a, b) {
  //     var result =
  //       a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
  //     return result * sortOrder;
  //   };
  // }

  // function sortDscDate(property) {
  //   var sortOrder = 1;
  //   if (property[0] === '-') {
  //     sortOrder = -1;
  //     property = property.substr(1);
  //   }
  //   return function (a, b) {
  //     var result =
  //       a[property] > b[property] ? -1 : a[property] > b[property] ? 1 : 0;
  //     return result * sortOrder;
  //   };
  // }
  // async function getTokenArr(from , to ,search ,  drpDownSelectedVal , selectedTokenType , selectedRefundable , selectedTokenValidity) {
  //   // ! loaders & internet connectivity check remaining
  //   Network.getStatus().then(async (status) => {
  //     if (status.connected) {
  //       const TokenFilters = {
  //         'Name Ascending': {
  //           key: 'name',
  //           isAscending: true,
  //         },
  //         'Name Descending': {
  //           key: 'name',
  //           isAscending: false,
  //         },
  //         'Oldest First': {
  //           key: 'created_at',
  //           isAscending: true,
  //         },
  //         'Latest First': {
  //           key: 'created_at',
  //           isAscending: false,
  //         },
  //       };

  //       var query ;
  //       query = supabase.from('Tokens')
  //       .select('*', { count: 'exact' })
  //       .order(TokenFilters[drpDownSelectedVal].key, {
  //         ascending: TokenFilters[drpDownSelectedVal].isAscending,
  //       })
  //       .range(from , to);

  //       if(search !== null || search !== '' || search !== undefined) {
  //         search = search.replace(/\s\s+/g, ' ')
  //         query = query.ilike('leadname', `%${search}%`);
  //       }

  //       // let { data: Tokens, error } = await supabase
  //       //   .from('Tokens')
  //       //   .select('*', { count: 'exact' })
  //       //   .order(TokenFilters[drpDownSelectedVal].key, {
  //       //     ascending: TokenFilters[drpDownSelectedVal].isAscending,
  //       //   });
  //       // console.log('Tokens: ', Tokens);
  //       // debugger;
  //       // if (Tokens) {
  //       //   const arr = Tokens.map((doc) => ({ ...doc, id: doc.tokenId }));
  //       //   // arr.sort(sortDscDate('created_at'));
  //       //   setTokenArr(arr);
  //       //   setFilteredTokenArr(arr);
  //       //   console.log(Tokens);
  //       // } else if (error) {
  //       //   console.log(error.message);
  //       // }
  //     } else {
  //       offlineToast();
  //     }
  //   });
  //   // ! error handling remaining
  // }

  function validatetTokenForm() {
    var form = true;
    if (tokenData.name === '') {
      form = false;
      setHelperText((preValue) => {
        preValue.isNameValid = 'Please Enter Token Name';
        return { ...preValue };
      });
    }
    if (tokenData.validity === null) {
      form = false;
      setHelperText((preValue) => {
        preValue.isValiditySelected = 'Please Select Validity';
        return { ...preValue };
      });
    }
    if (tokenData.inventoryTypeId === null) {
      form = false;
      setHelperText((preValue) => {
        preValue.isUnitTypeSelected = 'Please Select Unit Type';
        return { ...preValue };
      });
    }
    // if (paymentArr.length === 0) {
    //   form = false;
    //   setHelperText((preValue) => {
    //     preValue.isModeOfPaymentSelected = "Please Select Mode Of Payment";
    //     return { ...preValue };
    //   });
    // }
    if (tokenData.amount === '') {
      form = false;
      setHelperText((preValue) => {
        preValue.isAmountValid = 'Please Enter Amount';
        return { ...preValue };
      });
    }
    console.log(tokenData.shortCode);
    if (tokenData.shortCode === '') {
      form = false;
      setHelperText((preValue) => {
        preValue.shortCode = 'Please Enter short Code';
        return { ...preValue };
      });
    }
      if (tokenData.NoOfBookingAllow === '') {
      form = false;
      setHelperText((preValue) => {
        preValue.NoOfBookingAllow = 'Please Enter No of bookings allowed';
        return { ...preValue };
      });
    }  console.log('form', form)
    return {
    
      flag: form,
    };
  }

  async function sendTokenData() {
    let flag = validatetTokenForm();
    console.log('flag', flag)
    if (
      flag.flag &&
      // ! why check helper texts here? this should be done in validation function itself
      helperText.isNameValid === '' &&
      helperText.isAmountValid === '' &&
      helperText.isUnitTypeSelected === '' &&
      // helperText.isModeOfPaymentSelected === "" &&
      helperText.isValiditySelected === '' &&
      helperText.shortCode === '' &&
      helperText.NoOfBookingAllow === ''
    ) {
      console.log('add token');

      setTokenData((pre) => {
        pre.shortCode = tokenData.shortCode.toUpperCase();
        return { ...pre };
      });
      console.log(tokenData);
      let tokenField = { ...tokenData, amount: Math.ceil(tokenData.amount), canCustomerRefund: customerRefund };
      console.log({ tokenField });
      //!  loaders & internet connectivity check remaining
      Network.getStatus().then(async (status) => {
        if (status.connected) {
          const { data, error } = await supabase
            .from('Tokens')
            .insert(tokenField);
          if (data) {
            setOpenAddTokenModal(false);
            successTost('Token Added Successfully');
          } else {
            errorTost(error.message);
            console.log(error);
          }
        } else {
          offlineToast();
        }
      });
      // ! error handling remaining
    }
  }

  // let searchFilterArr = tokenArr;
  useEffect(() => {
    getUnitType();
  }, [openAddTokenModal]);

  useEffect(() => {
    dispatch(action.activeMenu('token'));
    // getTokenArr(drpDownSelectedVal);
    document.getElementById("input-with-icon-textfield Search").value = "";
    getAllTokens(0, false, search, drpDownSelectedVal, [], [], [])
  }, [openAddTokenModal]);

  // useEffect(() => {
  //   if (searchKey !== '' && filterType !== 'None') {
  //     if (filterType === 'Inventory Type') {
  //       let filter = [];
  //       console.log(filter.length);
  //       checkBoxDropDown.filter((each) => {
  //         if (each.checked === true) {
  //           filter.push(each.inventoryTypeId);
  //         }
  //       });
  //       if (filter.length !== 0) {
  //         // eslint-disable-next-line react-hooks/exhaustive-deps
  //         searchFilterArr = tokenArr.filter(
  //           (t) =>
  //             t.name.toLowerCase().includes(searchKey) &&
  //             filter.includes(t.inventoryTypeId)
  //         );
  //       }
  //     } else if (filterType === 'Date Range') {
  //       searchFilterArr = tokenArr.filter(
  //         (t) =>
  //           t.name.toLowerCase().includes(searchKey) &&
  //           t.created_at >= selectDates.startDate &&
  //           t.created_at <= selectDates.endDate
  //       );
  //     } else if (filterType === 'Price Range') {
  //       searchFilterArr = tokenArr.filter(
  //         (t) =>
  //           t.name.toLowerCase().includes(searchKey) &&
  //           t.amount >= priceRange[0] &&
  //           t.amount <= priceRange[1]
  //       );
  //     }
  //   } else if (searchKey !== '') {
  //     console.log(searchKey);
  //     searchFilterArr = tokenArr.filter((t) =>
  //       t.name.toLowerCase().includes(searchKey)
  //     );
  //   } else if (filterType !== 'None') {
  //     let filter = [];

  //     if (filterType === 'Inventory Type') {
  //       let filter = [];
  //       console.log(filter.length);
  //       checkBoxDropDown.filter((each) => {
  //         if (each.checked === true) {
  //           filter.push(each.inventoryTypeId);
  //         }
  //       });
  //       if (filter.length !== 0) {
  //         // eslint-disable-next-line react-hooks/exhaustive-deps
  //         searchFilterArr = tokenArr.filter(
  //           (t) =>
  //             t.name.toLowerCase().includes(searchKey) &&
  //             filter.includes(t.inventoryTypeId)
  //         );
  //       }
  //     } else if (filterType === 'Price Range') {
  //       searchFilterArr = tokenArr.filter(
  //         (f) => f.amount >= priceRange[0] && f.amount <= priceRange[1]
  //       );
  //     } else if (filterType === 'Date Range') {
  //       searchFilterArr = tokenArr.filter(
  //         (f) =>
  //           new Date(f.created_at) > selectDates.startDate &&
  //           new Date(f.created_at) < selectDates.endDate
  //       );
  //       console.log(searchFilterArr);
  //     }
  //   }
  //   // if (sortType !== 'None') {
  //   //   if (sortType === 'Name A -> Z') {
  //   //     setFilteredTokenArr(searchFilterArr.slice().sort(sortAscName('name')));
  //   //   } else if (sortType === 'Name Z -> A') {
  //   //     setFilteredTokenArr(searchFilterArr.slice().sort(sortDscName('name')));
  //   //   } else if (sortType === 'latest first') {
  //   //     setFilteredTokenArr(
  //   //       searchFilterArr.slice().sort(sortDscDate('created_at'))
  //   //     );
  //   //   } else if (sortType === 'oldest first') {
  //   //     setFilteredTokenArr(
  //   //       searchFilterArr.slice().sort(sortAscDate('created_at'))
  //   //     );
  //   //   }
  //   // } else {
  //   //   setFilteredTokenArr(searchFilterArr);
  //   // }
  //   // sortType,
  // }, [searchKey, priceRange, selectDates,checkBoxDropDown]) ;

  const selectedUnit = unitType.filter(
    (unit) => unit.inventoryTypeId === tokenData.inventoryTypeId
  );
  const selectedPreRequisite = TokenArray.filter(
    (token) => token.tokenId === tokenData.prerequisiteId
  );

  function clearFilters() {
    setTokenArray([]);
    setShowDropDown(false);
    setSelectedListDropDown([]);
    setListOfDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        select: false,
      }));
      pre[0].select = true;
      return [...pre];
    })
    setAllTokenTypesDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    })

    setAllRefundableDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    })

    setAllTokenValidityDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    })

    setShowAllTokenTypeDropDown(false);
    setShowAllRefundableDropDown(false);
    setShowAllTokenValidityDropDown(false);
    setSelectedTokenType([]);
    setSelectedRefundable([]);
    setSelectedTokenValidity([]);

  }

  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber)
    getAllTokens(passPageNumber, true, search, drpDownSelectedVal, selectedTokenType, selectedRefundable, selectedTokenValidity)
  }

  const debouncedFetchSearchData = debounce((e) => {
    setTokenArray([]);
    setSearch(e.target.value);
    setPageNumber(0);
    getAllTokens(
      0,
      false,
      e.target.value,
      drpDownSelectedVal,
      selectedTokenType,
      selectedRefundable,
      selectedTokenValidity,
    );
  }, 800);
  return (
    <div className='pageWrapper'>
      <div className={cssClasses.wrapperHeader}>
        <Box>
          <Box className={cssClasses.HeaderTitle}>All Tokens</Box>
        </Box>
        {/* {loggedInUser?.roleId?.accessibleTabs?.Sustenance['Site Visit'][
          'Add Site Visit'
        ]?.isAccessible && ( */}
        <Box>
          <Button
            style={{
              color: '#fff',
              backgroundColor: '#1570EF',
              fontSize: '1.4rem',
              lineHeight: '2rem',
              fontFamily: 'Roboto-Regular',
            }}
            padding={'0.8rem 2.6rem'}
            btnName={'Add Token'}
            btnIcon={<PlusIcon />}
            iconPosition={'left'}
            clicked={() => {
              setUpdateData(false);
              setModalType('Add Token');
              setTokenData({
                name: '',
                isPreselect: false,
                isPriorityPass: false,
                validity: null,
                inventoryTypeId: null,
                prerequisiteId: null,
                modeOfPayments: [],
                amount: '',
                isRefundable: 'Yes',
                paymentType:false,
                shortCode: '',
                NoOfBookingAllow:'1',
                isLocationEnabled: false,
                locations: [],
                isUnitTypeEnabled: false,
                unitTypes: [],
                allowedLeadTypes: []
              });

              // setFilterType('None');
              // setShowDates(false);
              // setShowPriceRange(false);
              // setCheckBoxDropDown([]);
              // setSelectedFilter('None');
              // setSortType('latest first');
              // if (filteredTokenArr.length > 0) {
              //   document.getElementById(
              //     'input-with-icon-textfield tokenSearchBar'
              //   ).value = '';
              //   setSearchKey('');
              // }
              setOpenAddTokenModal(true);
            }}
          />
        </Box>
        {/* )} */}
      </div>
      <Divider />

      <div className={cssClasses.wrapperFilters}>
        <div className={cssClasses.containerFilterSortBy}>
          <Box className={cssClasses.countTitle} mt={3}>
            {TokenCount} Tokens
          </Box>
          <div className={cssClasses.wrapperFilter}>
            <div className={cssClasses.filterTitle}>Filter by</div>
            <div className={cssClasses.wrapperDropDown}>
              <div
                className={cssClasses.wrapperCustomiseDropDown}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropDown(!showDropDown);
                }}
              >
                <div className={cssClasses.dropDownLabel}>
                  <span className={cssClasses.dropDownLabelValue}>
                    {selectedListDropDown.join()}
                  </span>
                  {selectedListDropDown.length === 0 && (
                    <span className={cssClasses.dropDownLabelValue}>None</span>
                  )}
                </div>
                <span>
                  {' '}
                  <KeyboardArrowDownIcon className={cssClasses.dropDownIcon} />
                </span>
              </div>
              {showDropDown && (
                <ClickAwayListener
                  onClickAway={() => {
                    setShowDropDown(false);
                  }}
                >
                  <div className={cssClasses.containerCustomiseDropDown}>
                    <div className={cssClasses.wrapperSelectAndCheckbox}>
                      <div className={cssClasses.wrapperEachSelect}>
                        {listOfDropDown.map((each, index) => {
                          return (
                            <div
                              className={
                                each.select
                                  ? cssClasses.selectedVal
                                  : cssClasses.containerEachSelect
                              }
                            >
                              <div
                                className={cssClasses.eachSelect}
                                onClick={() => {
                                  setListOfDropDown((pre) => {
                                    pre = pre.map((m) => ({
                                      ...m,
                                      select: false,
                                    }));
                                    // pre[index].select = true;
                                    return [...pre];
                                  });

                                  AllTokenTypesDropDown.forEach((el) => {
                                    if (el.value) {
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'Token Type'
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  AllRefundableDropDown.forEach((el) => {
                                    if (el.value) {
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'Refundable'
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });

                                  AllTokenValidityDropDown.forEach((el) => {
                                    if (el.value) {
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) =>
                                          label === 'Token Validity'
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  if (each.label === 'None') {
                                    setSelectedListDropDown([]);
                                    setSelectedTokenType([]);
                                    setSelectedRefundable([]);
                                    setSelectedTokenValidity([]);
                                    setListOfDropDown((pre) => {
                                      pre = pre.map((m) => ({
                                        ...m,
                                        select: false,
                                      }));
                                      pre[0].select = true;
                                      return [...pre];
                                    });

                                    AllTokenTypesDropDown.forEach((el) => {
                                      el.value = false;
                                    });
                                    AllRefundableDropDown.forEach((el) => {
                                      el.value = false;
                                    });

                                    AllTokenValidityDropDown.forEach((el) => {
                                      el.value = false;
                                    });

                                    setShowAllTokenTypeDropDown(false);
                                    setShowAllRefundableDropDown(false);
                                    setShowAllTokenTypeDropDown(false);
                                    // setShowDates(false);
                                  } else if (each.label === 'Token Type') {
                                    setShowAllTokenTypeDropDown(true);
                                    setShowAllRefundableDropDown(false);
                                    setShowAllTokenValidityDropDown(false);
                                    // setShowDates(false);
                                  } else if (each.label === 'Refundable') {
                                    setShowAllTokenTypeDropDown(false);
                                    setShowAllRefundableDropDown(true);
                                    setShowAllTokenValidityDropDown(false);
                                    // setShowDates(false);
                                  } else if (each.label === 'Token Validity') {
                                    setShowAllTokenTypeDropDown(false);
                                    setShowAllRefundableDropDown(false);
                                    setShowAllTokenValidityDropDown(true);
                                    // setShowDates(true);
                                  }
                                }}
                              >
                                {each.label}
                              </div>
                              {each.select && (
                                <img
                                  src={checked}
                                  alt={'checked'}
                                  style={{ marginRight: '2rem' }}
                                />
                              )}
                            </div>
                          );
                        })}
                      </div>
                      <div className={cssClasses.wrapperCheckbox}>
                        {showAllRefundableDropDown &&
                          AllRefundableDropDown.map((each, index) => {
                            return (
                              <FormGroup>
                                <FormControlLabel
                                  sx={[
                                    {
                                      '& .MuiTypography-root': {
                                        fontFamily: 'Inter-Medium !important',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        fontSize: '1.6rem !important',
                                        lineHeight: '2.4rem !important',
                                        /* identical to box height, or 150% */

                                        /* Gray/900 */

                                        color: '#101828',
                                      },
                                    },
                                  ]}
                                  checked={each.value}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setAllRefundableDropDown((pre) => {
                                        pre[index].value = e.target.checked;
                                        selectedRefundable.push(each.label);
                                        return [...pre];
                                      });
                                    } else {
                                      setAllRefundableDropDown((pre) => {
                                        pre[index].value = e.target.checked;
                                        return [...pre];
                                      });
                                      setSelectedRefundable(
                                        selectedRefundable.filter(
                                          (label) => label !== each.label
                                        )
                                      );
                                    }
                                    let checkTokenTypeSelected =
                                      AllRefundableDropDown.filter(
                                        ({ value }) => value === true
                                      );
                                    let indexOfMainList = findIndex(
                                      listOfDropDown,
                                      ({ label }) => label === 'Refundable'
                                    );
                                    if (checkTokenTypeSelected.length > 0) {
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                      if (
                                        selectedListDropDown.find(
                                          (value) => value === 'Refundable'
                                        ) === undefined
                                      ) {
                                        selectedListDropDown.push('Refundable');
                                      }
                                    } else {
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = false;
                                        return [...pre];
                                      });
                                      setSelectedListDropDown((pre) => [
                                        ...pre.filter(
                                          (value) => value !== 'Refundable'
                                        ),
                                      ]);
                                    }
                                  }}
                                  control={
                                    <Checkbox
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 28,
                                        },
                                      }}
                                    />
                                  }
                                  label={each.label}
                                />
                              </FormGroup>
                            );
                          })}
                        {showAllTokenValidityDropDown &&
                          AllTokenValidityDropDown.map((each, index) => {
                            return (
                              <FormGroup>
                                <FormControlLabel
                                  sx={[
                                    {
                                      '& .MuiTypography-root': {
                                        fontFamily: 'Inter-Medium !important',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        fontSize: '1.6rem !important',
                                        lineHeight: '2.4rem !important',
                                        /* identical to box height, or 150% */

                                        /* Gray/900 */

                                        color: '#101828',
                                      },
                                    },
                                  ]}
                                  checked={each.value}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setAllTokenValidityDropDown((pre) => {
                                        pre[index].value = e.target.checked;
                                        selectedTokenValidity.push(each.label);
                                        return [...pre];
                                      });
                                    } else {
                                      setAllTokenValidityDropDown((pre) => {
                                        pre[index].value = e.target.checked;
                                        return [...pre];
                                      });
                                      setSelectedTokenType(
                                        selectedTokenValidity.filter(
                                          (label) => label !== each.label
                                        )
                                      );
                                    }
                                    let checkTokenTypeSelected =
                                      AllTokenValidityDropDown.filter(
                                        ({ value }) => value === true
                                      );
                                    let indexOfMainList = findIndex(
                                      listOfDropDown,
                                      ({ label }) => label === 'Token Validity'
                                    );
                                    if (checkTokenTypeSelected.length > 0) {
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                      if (
                                        selectedListDropDown.find(
                                          (value) => value === 'Token Validity'
                                        ) === undefined
                                      ) {
                                        selectedListDropDown.push(
                                          'Token Validity'
                                        );
                                      }
                                    } else {
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = false;
                                        return [...pre];
                                      });
                                      setSelectedListDropDown((pre) => [
                                        ...pre.filter(
                                          (value) => value !== 'Token Validity'
                                        ),
                                      ]);
                                    }
                                  }}
                                  control={
                                    <Checkbox
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 28,
                                        },
                                      }}
                                    />
                                  }
                                  label={each.label}
                                />
                              </FormGroup>
                            );
                          })}

                        {showAllTokenTypeDropDown &&
                          AllTokenTypesDropDown.map((each, index) => {
                            return (
                              <FormGroup>
                                <FormControlLabel
                                  sx={[
                                    {
                                      '& .MuiTypography-root': {
                                        fontFamily: 'Inter-Medium !important',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        fontSize: '1.6rem !important',
                                        lineHeight: '2.4rem !important',
                                        /* identical to box height, or 150% */

                                        /* Gray/900 */

                                        color: '#101828',
                                      },
                                    },
                                  ]}
                                  checked={each.value}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setAllTokenTypesDropDown((pre) => {
                                        pre[index].value = e.target.checked;
                                        selectedTokenType.push(each.label);
                                        return [...pre];
                                      });
                                    } else {
                                      setAllTokenTypesDropDown((pre) => {
                                        pre[index].value = e.target.checked;
                                        return [...pre];
                                      });
                                      setSelectedTokenType(
                                        selectedTokenType.filter(
                                          (label) => label !== each.label
                                        )
                                      );
                                    }
                                    let checkTokenTypeSelected =
                                      AllTokenTypesDropDown.filter(
                                        ({ value }) => value === true
                                      );
                                    let indexOfMainList = findIndex(
                                      listOfDropDown,
                                      ({ label }) => label === 'Token Type'
                                    );
                                    if (checkTokenTypeSelected.length > 0) {
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                      if (
                                        selectedListDropDown.find(
                                          (value) => value === 'Token Type'
                                        ) === undefined
                                      ) {
                                        selectedListDropDown.push('Token Type');
                                      }
                                    } else {
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = false;
                                        return [...pre];
                                      });
                                      setSelectedListDropDown((pre) => [
                                        ...pre.filter(
                                          (value) => value !== 'Token Type'
                                        ),
                                      ]);
                                    }
                                  }}
                                  control={
                                    <Checkbox
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 28,
                                        },
                                      }}
                                    />
                                  }
                                  label={each.label}
                                />
                              </FormGroup>
                            );
                          })}
                      </div>
                    </div>
                    <div className={cssClasses.wrapperDropDownButtons}>
                      <div>
                        <Button
                          style={{
                            color: '#344054',
                            backgroundColor: '#ffffff',
                            fontSize: '1.4rem',
                            lineHeight: '2rem',
                          }}
                          padding={'0.8rem'}
                          btnName={'Clear'}
                          clicked={() => {
                            clearFilters();
                            getAllTokens(0, false, search, drpDownSelectedVal, [], [], [])
                          }}
                        />
                      </div>
                      <div>
                        <Button
                          style={{
                            color: '#ffffff',
                            backgroundColor: '#1570EF',
                            fontSize: '1.4rem',
                            lineHeight: '2rem',
                          }}
                          padding={'0.8rem'}
                          btnName={'Apply'}
                          clicked={() => {
                            setShowAllTokenTypeDropDown(false);
                            setShowAllRefundableDropDown(false);
                            setShowAllTokenValidityDropDown(false);
                            setShowDropDown(false);
                            setTokenArray([]);
                            setShowDropDown(false);
                            getAllTokens(
                              0,
                              false,
                              search,
                              drpDownSelectedVal,
                              selectedTokenType,
                              selectedRefundable,
                              selectedTokenValidity,
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              )}
            </div>
          </div>
          <div className={cssClasses.wrapperSortDropDown}>
            <div className={cssClasses.filterTitle}>Sort by</div>
            <div>
              <DropDown
                style={{
                  selectedColor: '#175CD3',
                  background: '#E8F0FE',
                }}
                selectedValue={drpDownSelectedVal}
                onChangeSelect={(_value) => {
                  // setSortType(e);
                  setDrpDownSelectedVal(_value);
                  // getTokenArr(_value);
                }}
                list={[
                  'Name Ascending',
                  'Name Descending',
                  'Latest First',
                  'Oldest First',
                ]}
              />
            </div>
          </div>
        </div>
        <div className={cssClasses.wrapperSearchBar}>
          {/* <SearchBar
            id={'StudentSearch'}
            value={search}
            placeholder={'Search By LeadName'}
            search={debouncedFetchSearchData}
            width='100%'
          /> */}

          <SearchBar
            id={'Search'}
            value={search}
            placeholder={'Search By Token Name'}
            search={debouncedFetchSearchData}
            width='100%'
          />
        </div>
      </div>


      {/* <div className={cssClasses.GridWrapper}> */}
      <DataGrid
        rows={TokenArray}
        columns={TokenGridColumns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        page={pageMaintain}
        onPageChange={(_page) => {
          console.log(_page);
          setPageMaintain(_page);
          if (pageNumber < _page) {
            getMoreData(_page);
            // setPageNumber(_page);
          }
        }}
        sx={[dataGridStyles]}
      />
      {/* </div> */}



      {openAddTokenModal && (
        <AddTokenModal
          open={openAddTokenModal}
          customerRefund={customerRefund}
          setCustomerRefund={setCustomerRefund}
          close={() => {
            // setPaymentArr([]);
            setOpenAddTokenModal(false);
            emptyHelperTextData();
          }}
          title={modalType}
          tokenData={tokenData}
          helperText={helperText}
          setHelperText={setHelperText}
          selectedUnit={selectedUnit}
          unitType={unitType}
          tokenArr={TokenArray}
          selectedPreRequisite={selectedPreRequisite}
          // paymentArr={paymentArr}
          // setPaymentArr={setPaymentArr}
          setTokenData={setTokenData}
          setOpenAddTokenModal={setOpenAddTokenModal}
          updateData={updateData}
          sendTokenData={sendTokenData}
          // handlePaymentSelection={(e) => handlePaymentSelection(e)}
          validatetTokenForm={validatetTokenForm}
        />
      )}
    </div>

    //     <div className={cssClasses.wrapper}>
    // {openAddTokenModal && (
    //   <AddTokenModal
    //     open={openAddTokenModal}
    //     close={() => {
    //       // setPaymentArr([]);
    //       setOpenAddTokenModal(false);
    //       emptyHelperTextData();
    //     }}
    //     title={modalType}
    //     tokenData={tokenData}
    //     helperText={helperText}
    //     setHelperText={setHelperText}
    //     selectedUnit={selectedUnit}
    //     unitType={unitType}
    //     tokenArr={tokenArr}
    //     selectedPreRequisite={selectedPreRequisite}
    //     // paymentArr={paymentArr}
    //     // setPaymentArr={setPaymentArr}
    //     setTokenData={setTokenData}
    //     setOpenAddTokenModal={setOpenAddTokenModal}
    //     updateData={updateData}
    //     sendTokenData={sendTokenData}
    //     // handlePaymentSelection={(e) => handlePaymentSelection(e)}
    //     validatetTokenForm={validatetTokenForm}
    //   />
    // )}

    // <div className={cssClasses.wrapperHeader}>
    //   <div className={cssClasses.titleWrapper}>
    //     <div className={cssClasses.headerTitle}>All Tokens</div>
    //     {/* //! hide sub title */}
    //     {/* <div className={cssClasses.headerSubTitle}>
    //     Lorem ipsum dolor sit amet consectetur adipisicing elit.
    //   </div> */}
    //   </div>
    //   <div className={cssClasses.btnWrapper}>
    //     <Button
    //       clicked={() => {
    //         setUpdateData(false);
    //         setModalType('Add Token');
    //         setTokenData({
    //           name: '',
    //           isPreselect: false,
    //           isPriorityPass: false,
    //           validity: null,
    //           inventoryTypeId: null,
    //           prerequisiteId: null,
    //           modeOfPayments: [],
    //           amount: '',
    //           isRefundable: 'Yes',
    //           shortCode: '',
    //         });
    //         setFilterType('None');
    //         setShowDates(false);
    //         setShowPriceRange(false);
    //         setCheckBoxDropDown([]);
    //         setSelectedFilter('None');
    //         // setSortType('latest first');
    //         if (filteredTokenArr.length > 0) {
    //           document.getElementById(
    //             'input-with-icon-textfield tokenSearchBar'
    //           ).value = '';
    //           setSearchKey('');
    //         }
    //         setOpenAddTokenModal(true);
    //       }}
    //       btnName={'Add Token'}
    //       btnIcon={<PlusIcon />}
    //       style={{
    //         color: '#fff',
    //         backgroundColor: '#1570EF',
    //         fontSize: '1.4rem',
    //         lineHeight: '2rem',
    //         fontFamily: 'Roboto-Regular',
    //       }}
    //       padding={'0.8rem 2.6rem'}
    //       iconPosition={'left'}
    //     />
    //   </div>
    // </div>
    // <div className={cssClasses.content}>
    //   <div className={cssClasses.totalProjects}>
    //     {/* //! show actual total count of tokens here from query */}
    //     <p>{`${filteredTokenArr.length} Tokens`}</p>
    //   </div>
    //   {tokenArr.length === 0 ? (
    //     ''
    //   ) : (
    //     <div className={cssClasses.wrapperFilters}>
    //       <div>
    //         <div className={cssClasses.wrapperFilter}>
    //           <div className={cssClasses.filterTitle}>Filter by</div>
    //           <div className={cssClasses.wrapperDropDown}>
    //             <div
    //               className={cssClasses.wrapperCustomiseDropDown}
    //               onClick={(e) => {
    //                 e.stopPropagation();
    //                 setShowDropDown(!showDropDown);
    //               }}
    //             >
    //               <div className={cssClasses.dropDownLabel}>
    //                 <span className={cssClasses.dropDownLabelValue}>
    //                   {selectedListDropDown.join()}
    //                 </span>
    //                 {selectedListDropDown.length === 0 && (
    //                   <span className={cssClasses.dropDownLabelValue}>None</span>
    //                 )}
    //               </div>
    //               <span>
    //                 {' '}
    //                 <KeyboardArrowDownIcon className={cssClasses.dropDownIcon} />
    //               </span>
    //             </div>
    //             {showDropDown && (
    //               <ClickAwayListener
    //                 onClickAway={() => {
    //                   setShowDropDown(false);
    //                 }}
    //               >
    //                 <div className={cssClasses.containerCustomiseDropDown}>
    //                   <div className={cssClasses.wrapperSelectAndCheckbox}>
    //                     <div className={cssClasses.wrapperEachSelect}>
    //                       {listOfDropDown.map((each, index) => {
    //                         return (
    //                           <div
    //                             className={
    //                               each.select
    //                                 ? cssClasses.selectedVal
    //                                 : cssClasses.containerEachSelect
    //                             }
    //                           >
    //                             <div
    //                               className={cssClasses.eachSelect}
    //                               // onClick={() => {
    //                               //   setListOfDropDown((pre) => {
    //                               //     pre = pre.map((m) => ({
    //                               //       ...m,
    //                               //       select: false,
    //                               //     }));
    //                               //     // pre[index].select = true;
    //                               //     return [...pre];
    //                               //   });

    //                               //   if (selectedDates != null) {
    //                               //     let indexOfMainList = findIndex(
    //                               //       listOfDropDown,
    //                               //       ({ label }) => label === 'Date'
    //                               //     );
    //                               //     setListOfDropDown((pre) => {
    //                               //       pre[indexOfMainList].select = true;
    //                               //       return [...pre];
    //                               //     });
    //                               //   }
    //                               //   AllCPDropDown.forEach((el) => {
    //                               //     if (el.value) {
    //                               //       let indexOfMainList = findIndex(
    //                               //         listOfDropDown,
    //                               //         ({ label }) => label === 'CP'
    //                               //       );
    //                               //       setListOfDropDown((pre) => {
    //                               //         pre[indexOfMainList].select = true;
    //                               //         return [...pre];
    //                               //       });
    //                               //     }
    //                               //   });
    //                               //   AllSalesDropDown.forEach((el) => {
    //                               //     if (el.value) {
    //                               //       let indexOfMainList = findIndex(
    //                               //         listOfDropDown,
    //                               //         ({ label }) => label === 'Sales'
    //                               //       );
    //                               //       setListOfDropDown((pre) => {
    //                               //         pre[indexOfMainList].select = true;
    //                               //         return [...pre];
    //                               //       });
    //                               //     }
    //                               //   });
    //                               //   if (each.label === 'None') {
    //                               //     setSelectedListDropDown([]);
    //                               //     setSelectedCp([]);
    //                               //     setSelectedSales([]);
    //                               //     setSelectedDates(null);
    //                               //     setSelectDates((pre) => {
    //                               //       pre[0].value = '';
    //                               //       pre[1].value = '';
    //                               //       return { ...pre };
    //                               //     });
    //                               //     setListOfDropDown((pre) => {
    //                               //       pre = pre.map((m) => ({
    //                               //         ...m,
    //                               //         select: false,
    //                               //       }));
    //                               //       pre[0].select = true;
    //                               //       return [...pre];
    //                               //     });
    //                               //     if (
    //                               //       selectDates.startDate === '' ||
    //                               //       selectDates.endDate === ''
    //                               //     ) {
    //                               //       setListOfDropDown((pre) => {
    //                               //         pre[1].select = false;
    //                               //         return [...pre];
    //                               //       });
    //                               //     }
    //                               //     AllCPDropDown.forEach((el) => {
    //                               //       el.value = false;
    //                               //     });
    //                               //     AllSalesDropDown.forEach((el) => {
    //                               //       el.value = false;
    //                               //     });

    //                               //     setShowAllCPDropDown(false);
    //                               //     setShowAllSalesDropDown(false);
    //                               //     setShowDates(false);
    //                               //   } else if (each.label === 'CP') {
    //                               //     setTimeout(() => {
    //                               //       let _val = document.getElementById(
    //                               //         'input-with-icon-textfield DropDownLeadCpSearch'
    //                               //       );
    //                               //       if (_val) {
    //                               //         _val.value = DropDownCpSearch;
    //                               //       }
    //                               //     }, 100);
    //                               //     setShowAllCPDropDown(true);
    //                               //     setShowAllSalesDropDown(false);
    //                               //     setShowDates(false);
    //                               //   } else if (each.label === 'Sales') {
    //                               //     setTimeout(() => {
    //                               //       let _val = document.getElementById(
    //                               //         'input-with-icon-textfield DropDownLeadSalesSearch'
    //                               //       );
    //                               //       if (_val) {
    //                               //         _val.value = DropdownSalesSearch;
    //                               //       }
    //                               //     }, 100);
    //                               //     setShowAllCPDropDown(false);
    //                               //     setShowAllSalesDropDown(true);
    //                               //     setShowDates(false);
    //                               //   } else if (each.label === 'Date') {
    //                               //     setShowAllCPDropDown(false);
    //                               //     setShowAllSalesDropDown(false);
    //                               //     setShowDates(true);
    //                               //   }
    //                               // }}
    //                             >
    //                               {each.label}
    //                             </div>
    //                             {each.select && (
    //                               <img
    //                                 src={checked}
    //                                 alt={'checked'}
    //                                 style={{ marginRight: '2rem' }}
    //                               />
    //                             )}
    //                           </div>
    //                         );
    //                       })}
    //                     </div>
    //                     <div className={cssClasses.wrapperCheckbox1}>
    //                       <div className={cssClasses.wrapperCheckbox}></div>
    //                     </div>
    //                   </div>
    //                   <div className={cssClasses.wrapperDropDownButtons}>
    //                     <div>
    //                       <Button
    //                         style={{
    //                           color: '#344054',
    //                           backgroundColor: '#ffffff',
    //                           fontSize: '1.4rem',
    //                           lineHeight: '2rem',
    //                         }}
    //                         padding={'0.8rem'}
    //                         btnName={'Clear'}
    //                         clicked={() => {
    //                           clearFilters();
    //                         }}
    //                       />
    //                     </div>
    //                     <div>
    //                       <Button
    //                         style={{
    //                           color: '#ffffff',
    //                           backgroundColor: '#1570EF',
    //                           fontSize: '1.4rem',
    //                           lineHeight: '2rem',
    //                         }}
    //                         padding={'0.8rem'}
    //                         btnName={'Apply'}
    //                         // clicked={() => {
    //                         //   if (
    //                         //     selectDates[1].value === '' &&
    //                         //     selectedDates !== null
    //                         //   ) {
    //                         //     setHelperText((pre) => {
    //                         //       pre.endDate = 'Please Select end Date';
    //                         //       return { ...pre };
    //                         //     });
    //                         //     setShowDates(true);
    //                         //   } else {
    //                         //     setHelperText((pre) => {
    //                         //       pre.endDate = '';
    //                         //       return { ...pre };
    //                         //     });
    //                         //     setShowDates(false);
    //                         //   }
    //                         //   setShowAllCPDropDown(false);
    //                         //   setShowAllSalesDropDown(false);

    //                         //   setShowDropDown(false);
    //                         //   console.log(helperText);
    //                         //   if (
    //                         //     helperText.startDate === '' &&
    //                         //     helperText.endDate === ''
    //                         //   ) {
    //                         //     setAllSitesData([]);
    //                         //     setShowDropDown(false);
    //                         //     getAllSitesFromServer(
    //                         //       0,
    //                         //       false,
    //                         //       search,
    //                         //       drpDownSelectedVal,
    //                         //       selectedCp,
    //                         //       selectedSales,
    //                         //       selectDates,
    //                         //       selectedDates
    //                         //     );
    //                         //   } else {
    //                         //     setShowDropDown(true);
    //                         //   }
    //                         // }}
    //                       />
    //                     </div>
    //                   </div>
    //                 </div>
    //               </ClickAwayListener>
    //             )}
    //           </div>
    //         </div>
    //         {/* <div className={cssClasses.filterElement}>
    //         <div className={cssClasses.label}>
    //           <p>Filter by</p>
    //         </div>
    //         <div className={cssClasses.wrapperDropDown}>
    //           <div
    //             className={cssClasses.wrapperCustomiseDropDown}
    //             onClick={(e) => {
    //               e.stopPropagation();
    //               setShowDropDown(!showDropDown);
    //             }}
    //           >
    //             {filterType}
    //             <img
    //               src={dropDownIcon}
    //               alt={'icon'}
    //               className={cssClasses.dropDownIcon}
    //             ></img>
    //           </div>
    //           {showDropDown && (
    //             <ClickAwayListener
    //               onClickAway={() => {
    //                 setShowDropDown(false);
    //               }}
    //             >
    //               <div className={cssClasses.containerCustomiseDropDown}>
    //                 <div className={cssClasses.wrapperSelectAndCheckbox}>
    //                   <div className={cssClasses.wrapperEachSelect}>
    //                     {listOfDropDown.map((each) => {
    //                       return (
    //                         <div
    //                           className={
    //                             selectFilter === each
    //                               ? cssClasses.selectedVal
    //                               : cssClasses.containerEachSelect
    //                           }
    //                         >
    //                           <div
    //                             className={cssClasses.eachSelect}
    //                             onClick={() => {
    //                               console.log(each);
    //                               setSelectedFilter(each);
    //                               if (each === 'None') {
    //                                 setFilterType('None');
    //                                 setShowDates(false);
    //                                 setShowPriceRange(false);
    //                                 setCheckBoxDropDown([]);
    //                               } else if (each === 'Price Range') {
    //                                 setFilterType('Price Range');
    //                                 setShowDates(false);
    //                                 setCheckBoxDropDown([]);
    //                                 setShowPriceRange(true);
    //                               } else if (each === 'Inventory Type') {
    //                                 setFilterType('Inventory Type');
    //                                 setShowDates(false);
    //                                 setCheckBoxDropDown(unitType);
    //                                 setShowPriceRange(false);
    //                               } else if (each === 'Date Range') {
    //                                 setFilterType('Date Range');
    //                                 setShowDates(true);
    //                                 setShowPriceRange(false);
    //                               }
    //                             }}
    //                           >
    //                             {each}
    //                           </div>
    //                           {selectFilter === each && (
    //                             <img
    //                               src={checked}
    //                               alt={'checked'}
    //                               style={{ marginRight: '2rem' }}
    //                             />
    //                           )}
    //                         </div>
    //                       );
    //                     })}
    //                   </div>

    //                   <div className={cssClasses.wrapperCheckbox}>
    //                     {showDates === false &&
    //                       checkBoxDropDown?.map((each, index) => {
    //                         return (
    //                           <FormGroup>
    //                             <FormControlLabel
    //                               sx={[
    //                                 {
    //                                   '& .css-ahj2mt-MuiTypography-root': {
    //                                     fontFamily:
    //                                       'Inter-Medium !important',
    //                                     fontStyle: 'normal',
    //                                     fontWeight: '400',
    //                                     fontSize: '1.6rem !important',
    //                                     lineHeight: '2.4rem !important',
    //                                     color: '#101828',
    //                                   },
    //                                 },
    //                               ]}
    //                               checked={each.checked}
    //                               onChange={(e) => {
    //                                 console.log(e.target.checked);
    //                                 setCheckBoxDropDown((pre) => {
    //                                   pre[index].checked = e.target.checked;
    //                                   return [...pre];
    //                                 });
    //                                 console.log(checkBoxDropDown);
    //                               }}
    //                               control={
    //                                 <Checkbox
    //                                   sx={{
    //                                     '& .MuiSvgIcon-root': {
    //                                       fontSize: 28,
    //                                     },
    //                                   }}
    //                                 />
    //                               }
    //                               label={each.type}
    //                             />
    //                           </FormGroup>
    //                         );
    //                       })}
    //                     {showDates && (
    //                       <div>
    //                         <div className={cssClasses.dateDivider}>
    //                           <div className={cssClasses.label}>
    //                             Start Date
    //                           </div>
    //                           <DateComponent
    //                             value={selectDates.startDate}
    //                             onChangeDate={(value) => {
    //                               setSelectDates((pre) => {
    //                                 pre.startDate = value;
    //                                 return { ...pre };
    //                               });
    //                             }}
    //                             helperText={''}
    //                             minDate={new Date('11 / 01 / 2022')}
    //                           ></DateComponent>
    //                         </div>
    //                         <div>
    //                           <div className={cssClasses.label}>
    //                             End Date
    //                           </div>
    //                           <DateComponent
    //                             value={selectDates.endDate}
    //                             onChangeDate={(value) => {
    //                               setSelectDates((pre) => {
    //                                 pre.endDate = value;
    //                                 return { ...pre };
    //                               });
    //                             }}
    //                             helperText={''}
    //                             minDate={new Date('11 / 01 / 2022')}
    //                           ></DateComponent>
    //                         </div>
    //                       </div>
    //                     )}
    //                     <div className={cssClasses.priceRange}>
    //                       {showPriceRange && (
    //                         <div className={cssClasses}>
    //                           <Box
    //                             sx={
    //                               window.innerWidth > 820
    //                                 ? { width: 300 }
    //                                 : { width: 200 }
    //                             }
    //                           >
    //                             <Slider
    //                               value={priceRange}
    //                               onChange={(e) => {
    //                                 setPriceRange(e.target.value);
    //                                 console.log(priceRange);
    //                               }}
    //                               valueLabelDisplay='auto'
    //                               step={5000}
    //                               marks={[
    //                                 {
    //                                   value: 10000,
    //                                   label: '10000',
    //                                 },
    //                                 {
    //                                   value: 50000,
    //                                   label: '50000',
    //                                 },
    //                                 {
    //                                   value: 100000,
    //                                   label: '100000',
    //                                 },
    //                               ]}
    //                               min={10000}
    //                               max={100000}
    //                             />
    //                           </Box>
    //                         </div>
    //                       )}
    //                     </div>
    //                   </div>
    //                 </div>
    //               </div>
    //             </ClickAwayListener>
    //           )}
    //         </div>
    //       </div> */}

    //         <div className={cssClasses.wrapperSortDropDown}>
    //           <div className={cssClasses.filterTitle}>Sort by</div>
    //           <DropDown
    //             style={{
    //               selectedColor: '#175CD3',
    //               background: '#E8F0FE',
    //             }}
    //             selectedValue={drpDownSelectedVal}
    //             onChangeSelect={(_value) => {
    //               // setSortType(e);
    //               setDrpDownSelectedVal(_value);
    //               getTokenArr(_value);
    //             }}
    //             list={[
    //               'Name Ascending',
    //               'Name Descending',
    //               'Latest First',
    //               'Oldest First',
    //             ]}
    //           />
    //         </div>
    //       </div>
    //       <div className={cssClasses.wrapperSearchBar}>
    //         <SearchBar
    //           placeholder={'Search by token name'}
    //           search={(e) => setSearchKey(e.target.value.toLowerCase())} // ! remaining search functionality
    //           id={'tokenSearchBar'}
    //         />
    //       </div>
    //     </div>
    //   )}
    //   <div className={cssClasses.gridWrapper}>
    //     {filteredTokenArr.length === 0 ? (
    //       <div className={cssClasses.noTokensWrapper}>
    //         <img src={noTokenImg} alt='' />
    //         <p>No token found</p>
    //         <span>
    //           No tokens created. Click on the “+Add Token” Button to create a new
    //           Token.
    //         </span>
    //         <div
    //           style={{
    //             marginTop: '2rem',
    //           }}
    //         >
    //           <Button
    //             clicked={() => {
    //               setUpdateData(false);
    //               setTokenData({
    //                 name: '',
    //                 isPreselect: false,
    //                 isPriorityPass: false,
    //                 validity: null,
    //                 inventoryTypeId: null,
    //                 prerequisiteId: null,
    //                 modeOfPayments: [],
    //                 amount: '',
    //                 isRefundable: 'Yes',
    //                 shortCode: '',
    //               });
    //               setFilterType('None');
    //               setShowDates(false);
    //               setShowPriceRange(false);
    //               setCheckBoxDropDown([]);
    //               setSelectedFilter('None');
    //               // setSortType('latest first');
    //               if (filteredTokenArr.length > 0) {
    //                 document.getElementById(
    //                   'input-with-icon-textfield tokenSearchBar'
    //                 ).value = '';
    //                 setSearchKey('');
    //               }
    //               setSearchKey('');
    //               setOpenAddTokenModal(true);
    //             }}
    //             btnName={'Add Token'}
    //             btnIcon={<AddIcon style={{ width: '2rem', height: '2rem' }} />}
    //             style={{
    //               borderRadius: '0.4rem',
    //               backgroundColor: '#1570EF',
    //               color: '#FFFFFF',
    //               fontSize: '1.4rem',
    //               fontWeight: '400',
    //               lineHeight: '2rem',
    //               textAlign: 'center',
    //             }}
    //             padding={'0.8rem 2.6rem'}
    //             iconPosition={'left'}
    //           />
    //         </div>
    //       </div>
    //     ) : (
    //       <Datagrid columns={projectGridColums} rows={filteredTokenArr} />
    //     )}
    //   </div>
    // </div>
    //     </div>;
  );
}

export default Token;
